export const skipToContentComponent = {
  key: 'skipToContentComponent',
  name: 'Skip To Content Component',
  siteIdentifier: 'global',

  skipToContentLinkButton: 'Skip to content',
};
